module.exports = __webpack_public_path__ + "img/treppenaufgang_2.b854fe36.webp";